// BetaAccessModal Component
// Displays a modal when beta tester access is required

import React from 'react';
import { RevoltModal } from './RevoltModal';
import { RevoltButton } from './RevoltButton';

export function BetaAccessModal({ isOpen, onClose }) {
  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Beta Access Required"
      showCloseButton={true}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontSize: '3rem',
          marginBottom: '1rem',
          color: '#f59e0b'
        }}>
          🎯
        </div>

        <p style={{
          fontSize: '1.1rem',
          marginBottom: '1.5rem',
          color: '#ccc'
        }}>
          This feature is currently available only to beta testers.
        </p>

        <p style={{
          fontSize: '0.95rem',
          marginBottom: '2rem',
          color: '#999'
        }}>
          Your account is not currently marked as a beta tester,
          so you don't have access to this beta feature.
        </p>

        <RevoltButton
          onClick={onClose}
          variant="primary"
          style={{ minWidth: '120px' }}
        >
          Got it
        </RevoltButton>
      </div>
    </RevoltModal>
  );
}